import { combineReducers } from "@reduxjs/toolkit";
import { UserLoginState } from "../../Login/redux/loginSlice.types";
import routePlanningSlice from "../../RoutePlanning/redux/planningSlice";
import usersSlice from "../../Users/redux/usersSlice";
import userLoginSlice from "../../Login/redux/loginSlice";
import commonSlice from "./common/commonSlice";
import codReconciliationSlice from "../../Dashboard/ReconciliationDashboard/redux/reconciliationSlice";
import { PlanningOrderListState } from "../../RoutePlanning/redux/planningSlice.types";
import { CodReconciliationState } from "../../Dashboard/ReconciliationDashboard/redux/reconciliationSlice.types";
import { CommonState } from "./common/commonSlice.types";
import { UsersState } from "../../Users/redux/usersSlice.types";
import { PerformanceState } from "../../Dashboard/PerformanceDashboard/redux/performanceSlice.types";
import performanceSlice from "../../Dashboard/PerformanceDashboard/redux/performanceSlice";
import { RouteTrackingState } from "RouteTracking/redux/routeTrackingSlice.types";
import routeTrackingSlice from "../../RouteTracking/redux/routeTrackingSlice";
import hubSlice from "../../Hubs/redux/hubSlice";
import hubWiseDashboardSlice from "../../Dashboard/HubwiseDashboard/redux/hubWiseSlice";
import { HubState } from "Hubs/redux/hubSlice.types";
import { HubWiseState } from "Dashboard/HubwiseDashboard/redux/hubWiseSlice.types";
import { CNCOrderListState } from "../../ClickAndCollect/redux/clickAndCollectSlice.types";
import clickAndCollectSlice from "../../ClickAndCollect/redux/clickAndCollectSlice";
import valetTrolleySlice from "ValetTrolley/redux/valetTrolleySlice";
import { ValetTrolleyState } from "../../ValetTrolley/redux/valetTrolleySlice.types";
import carrefourDeliverySlice from "CarrefourDelivery/redux/carrefourDeliverySlice";
import { CarrefourDeliveryState } from "../../CarrefourDelivery/redux/carrefourDeliverySlice.types";
import { DelveDashboardState } from "../../Delve/OrderList/redux/delveSlice.types";
import delveSlice from "../../Delve/OrderList/redux/delveSlice";
import { ExpressDashboardState } from "Express/redux/expressSlice.types";
import expressSlice from "Express/redux/expressSlice";
import customerCommSlice from "CustomerCommunication/redux/customerCommSlice";
import { CustomerCommState } from "CustomerCommunication/redux/customerCommSlice.types";
import { DriversDashboardState } from "DriverManagement/redux/driversSlice.types";
import driversSlice from "DriverManagement/redux/driversSlice";
import { CODReconState } from "CODPortal/express/redux/codPortalSlice.types";
import codPortalSlice from "CODPortal/express/redux/codPortalSlice";
import DelveDashboardSlice from "../../Delve/Dashboard/Redux/DelveDashboardSlice";
import { DelveDashboardSliceState } from "../../constants/DelveDashboardConstant";
import { StdCodReconState } from "CODPortal/standard/redux/stdCodPortalSlice.types";
import stdCodPortalSlice from "CODPortal/standard/redux/stdCodPortalSlice";
import stagingAreaSlice from "../../StagingArea/redux/stagingAreaSlice";
// All Routes
import { AllRoutesSliceInitialState } from "../../RoutePlanning/AllRoutes/utils/AllRouteConstant";
import allRoutesSlice from "../../RoutePlanning/AllRoutes/redux/allRoutesSlice";
//
import StoreManagementSlice from "../../StoreManagement/redux/StoreManagementSlice";
import { StoreManagementState } from "../../StoreManagement/redux/StoreManagementSlice.type";
import  ReportSlice  from "../../Reports/redux/reportSlice";
import { ReportState } from "../../Reports/redux/reportSlice.types";
import { NotificationCenterState } from "NotificationCenter/redux/notificationCenterSlice.types";
import notificationCenterSlice from "NotificationCenter/redux/notificationCenterSlice";
import DownloadAppSlice from "../../DownloadApp/redux/downloadAppSlice";
import { DownloadAppState } from "../../DownloadApp/redux/downloadAppSlice.types";
import  DriverHelperTipSlice  from "../../DriverHelperTip/redux/DriverHelperTipSlice";
import { DriverHelperTipState } from "../../DriverHelperTip/redux/DriverhelperTipSlice.type";
import  DriverLocationsSlice  from "../../DriverLocations/redux/DriverLocationsSlice";
import { DriverLocationsState } from "../../DriverLocations/redux/DriverLocationsSlice.type";
import  ConsignmentDetailsSlice  from "../../DriverLocations/redux/ConsignmentDetailsSlice";
import { ConsignmentDetailsState } from "../../DriverLocations/redux/ConsignmentDetailsSlice.type";
import orderListSlice from "../../orderList/redux/orderListSlice";
import { OrderListState } from "../../orderList/redux/orderListSlice.types";
import ReturnsListSlice from "../../ReturnList/redux/returnsListSlice";
import { ReturnsListState } from "../../ReturnList/redux/returnsListSlice.types";
import exportInitiatedDialogReducer from 'ExportIntiaiedDialog/redux/exportInitiatedDialogSlice';

import PODSlice from "../../POD/redux/PODSlice";
import { PODState } from "../../POD/redux/PODSlice.types";
import SharedSlice from "../../SharedComponent/redux/sharedSlice";
import { SharedState } from "../../SharedComponent/redux/sharedSlice.types";
import onBoardingSlice from "../../OnBoarding/redux/onBoardingSlice";
import { OnBoardingState } from "../../OnBoarding/redux/onBoardingSlice.types";

const reducers = {
  userLogin: userLoginSlice,
  common: commonSlice,
  users: usersSlice,
  routePlanning: routePlanningSlice,
  codReconciliation: codReconciliationSlice,
  performance: performanceSlice,
  routeTracking: routeTrackingSlice,
  hub: hubSlice,
  hubWise: hubWiseDashboardSlice,
  clickAndCollect: clickAndCollectSlice,
  valetTrolley: valetTrolleySlice,
  carrefourDelivery: carrefourDeliverySlice,
  delveOrderList: delveSlice, // Delve Order List
  expressDashboard: expressSlice,
  drivers: driversSlice,
  codPortal: codPortalSlice,
  delveDashboard: DelveDashboardSlice,
  stdCodPortal: stdCodPortalSlice,
  stagingArea: stagingAreaSlice,
  allRoutes: allRoutesSlice,
  customerCommunication: customerCommSlice,
  storeManagement: StoreManagementSlice,
  report: ReportSlice,
  notificationCenter: notificationCenterSlice,
  DownloadApp: DownloadAppSlice,
  driverHelperTip: DriverHelperTipSlice,
  driverLocations: DriverLocationsSlice,
  consignmentDetails: ConsignmentDetailsSlice,
  orderList: orderListSlice, // Order List
  returnsList: ReturnsListSlice, // Returns List
  exportInitiatedDialog: exportInitiatedDialogReducer,
  pod: PODSlice,
  sharedSlice: SharedSlice,
  onBoarding: onBoardingSlice,
};

export interface AppState {
  userLogin: UserLoginState;
  routePlanning: PlanningOrderListState;
  users: UsersState;
  common: CommonState;
  codReconciliation: CodReconciliationState;
  performance: PerformanceState;
  routeTracking: RouteTrackingState;
  hub: HubState;
  hubWise: HubWiseState;
  clickAndCollect: CNCOrderListState;
  valetTrolley: ValetTrolleyState;
  carrefourDelivery: CarrefourDeliveryState;
  delveOrderList: DelveDashboardState;
  expressDashboard: ExpressDashboardState;
  drivers: DriversDashboardState;
  codPortal: CODReconState;
  delveDashboard: DelveDashboardSliceState;
  stdCodPortal: StdCodReconState;
  stagingArea: any;
  allRoutes: AllRoutesSliceInitialState;
  customerCommunication: CustomerCommState;
  storeManagement: StoreManagementState;
  report: ReportState;
  notificationCenter: NotificationCenterState;
  DownloadApp: DownloadAppState;
  driverHelperTip: DriverHelperTipState;
  driverLocations: DriverLocationsState;
  consignmentDetails: ConsignmentDetailsState;
  orderList: OrderListState;
  returnsList: ReturnsListState;
  pod: PODState;
  sharedSlice: SharedState;
  onBoarding: OnBoardingState;
}

export default combineReducers(reducers);
